<script>
import { mapActions, mapGetters } from "vuex";
import { BaseIcon, BaseSelect } from "@/components";
import { getItem } from "../../utils/tokenTools";
import mixins from "../../mixins";

export default {
  name: "CustomerInfo",
  components: {
    BaseIcon,
    BaseSelect,
  },
  mixins: [mixins],
  data() {
    return {
      userType: null,
      esube: getItem("esube"),
    };
  },
  props: {
    currentCustomer: Object,
    customerNumber: String,
    getPaymentStatuses: Array,
  },
  computed: {
    ...mapGetters(["getFilterList", "getUserInfo"]),
    customerId() {
      return this.customerNumber;
    },
  },
  methods: {
    ...mapActions(["updatePaymentStatus"]),
    navigate() {
      const params = {
        customerNumber: this.customerId,
      };
      const query = {};
      let cusId = this.$route.params.customerId;
      params.customerId =
        cusId !== undefined ? cusId : localStorage.getItem("userId");
      query.c = params.customerId;
      this.$router.push({
        name: "BuyDataPackage",
        params,
        query,
      });
    },
    priceLink() {
      window.open(
        "https://www.osmanlimenkul.com.tr/hisse-ve-viop/platformlarimiz/canli-data-ve-platformlar/data-ve-platform-kullanim-ucretleri",
        "_blank",
        "noopener"
      );
    },
    changeStatus(value) {
      if (value) {
        const args = {
          customerId: this.currentCustomer.id,
          paymentStatusId: value.code,
        };
        this.updatePaymentStatus(args).then((res) => {
          if (res) {
            this.$toast.success("Müşteri durumu güncellendi.");
            this.$emit("paymentStatusChanged", true);
          }
        });
      }
    },
  },
};
</script>

<template>
  <div class="customer-info" v-if="esube == 'no'">
    <div class="custom-container componenet-title-border-bottom">
      <div class="component-title">Müşteri Bilgisi</div>
    </div>
    <div class="custom-container">
      <div class="left-side">
        <div class="avatar">
          <img
            v-if="currentCustomer && currentCustomer.imageUrl"
            alt="no-user"
            :src="currentCustomer.imageUrl"
          />
          <base-icon
            v-else
            name="no-user"
            width="90"
            height="90"
            class="mx-auto block"
          />
        </div>
        <div v-if="currentCustomer" class="user-info">
          <div class="name-surname">
            <h6>{{ currentCustomer.name }} {{ currentCustomer.surName }}</h6>
          </div>
          <div class="address" v-if="currentCustomer.address">
            <span>{{ currentCustomer.address }}</span>
            <span v-if="currentCustomer.district"
              >/ {{ currentCustomer.district }}</span
            >
            <span v-if="currentCustomer.cityName"
              >/ {{ currentCustomer.cityName }}</span
            >
            <span v-if="currentCustomer.countryName"
              >/ {{ currentCustomer.countryName }}</span
            >
          </div>
          <div class="phone-boxes">
            <div class="gray-box">
              <base-icon class="icon" name="person" />
              <span>{{ currentCustomer.customerNo }}</span>
            </div>
            <div class="gray-box">
              <base-icon class="icon" name="phone" />
              <span>
                <a :href="'tel:' + currentCustomer.phoneNumber">{{
                  currentCustomer.phoneNumber
                }}</a>
              </span>
            </div>
            <div class="gray-box">
              <base-icon class="icon" name="email" />
              <span>
                <a :href="'mailto:' + currentCustomer.email">{{
                  currentCustomer.email
                }}</a>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="right-side">
        <div class="description customer-dropdown">
          <span class="bold">Masraf Ödeme Durumu</span>
          <base-select
            v-if="getPaymentStatuses.length > 0"
            :options="getPaymentStatuses"
            id="paymentStatus"
            @change="changeStatus"
            :selectedId="Number(currentCustomer.paymentStatusId)"
            :setSmallFontsForOptions="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.customer-info {
  padding: 0px;

  .component-title {
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    border-bottom: var(--color-primary-tint-second);
    @media (max-width: 768px) {
      font-size: 16px;
    }
  }

  .custom-container {
    display: flex;
    height: auto;
    background: var(--grayscale-0);
    padding: 20px;
    @media screen and (max-width: 1146px) {
      display: block;
    }
    &.componenet-title-border-bottom {
      border-bottom: 1px solid var(--color-primary-tint-second);
      padding: 15px 20px;
    }
  }

  .left-side {
    flex: 1.1;
    display: flex;
    flex-direction: row;
    align-items: center;
    @media screen and (max-width: 711px) {
      display: block;
    }
    .avatar {
      svg {
        display: block;
        margin: 0 auto;
      }
      img {
        width: 90px;
        height: 90px;
        @media screen and (max-width: 711px) {
          display: block;
          margin: auto;
        }
      }
    }
    .user-info {
      padding-left: 20px;

      @media screen and (max-width: 768px) {
        padding-left: 0px;
        text-align: center;
      }

      .name-surname {
        h6 {
          font-feature-settings: "clig" off, "liga" off;
          font-size: 16px;
          font-style: normal;
          font-weight: 500;
          line-height: 24px;
        }
        .bold {
          font-weight: 700;
        }
      }

      .description {
        margin-top: 20px;
        display: flex;
        align-items: center;
        @media screen and (max-width: 711px) {
          flex-wrap: wrap;
          justify-content: center;
        }
        span {
          color: var(--grayscale-50);
        }
        h6 {
          margin-left: 5px;
        }
      }
      .address {
        span {
          font-size: 12px;
          color: var(--grayscale-50);
        }
      }
      .phone-boxes {
        display: flex;
        margin-top: 10px;
        flex-wrap: wrap;

        @media screen and (max-width: 711px) {
          text-align: center;
          align-content: center;
          justify-content: center;
        }
        @media screen and (max-width: 440px) {
          flex-wrap: wrap;
        }
        .gray-box {
          padding: 4px 20px;
          display: flex;
          align-items: center;
          gap: 16px;
          position: relative;
          background: var(--color-primary-zebra);
          border-radius: var(--radius-five);

          @media screen and (max-width: 1145px) {
            border-bottom: 1px solid var(--color-primary-tint-second);
          }

          @media screen and (max-width: 440px) {
            gap: 0;
            padding: 5px;
            margin: 0px;
            &:last-of-type {
              margin: 0;
            }
          }
          span {
            font-size: 12px;
            color: var(--color-primary-rates);
            font-weight: 700;
          }

          a:link {
            text-decoration: none;
            color: var(--color-primary-rates);
          }
          &::after {
            content: "";
            width: 1px;
            display: block;
            background: var(--grayscale-110);
            height: 50%;
            position: absolute;
            right: 0px;
            top: 50%;
            transform: translateY(-50%);
          }
          @media (max-width: 575px) {
            &:nth-child(2)::after {
              display: none;
            }
          }
          &:last-child {
            &::after {
              display: none;
            }
          }
        }
      }
    }
  }
  .right-side {
    flex: 0.6;
    display: flex;
    align-items: center;
    justify-content: right;

    .description {
      width: 100%;
      span {
        display: block;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 150% */
        margin-bottom: 5px;
      }
    }
    @media screen and (max-width: 711px) {
      justify-content: center;
    }

    @media screen and (max-width: 1145px) {
      justify-content: flex-start;
      margin-top: 10px;
    }
    button {
      max-width: 210px;
    }
  }
  @media screen and (max-width: 1024px) {
    .buy-package {
      margin-top: 14px;
      height: 35px;
    }
  }
  .buy-package {
    &.mr-5 {
      margin-right: 5px;
    }
  }
}
@media only screen and (max-width: 600px) {
  .customer-info {
    flex-direction: column;
    .right-side {
      align-items: center;
    }
  }
}
</style>
<style lang="scss">
.osm-vd {
  .customer-dropdown .form-group {
    #paymentStatus {
      .vs__dropdown-toggle {
        border: 0;
        padding: 0;
        min-width: auto;
        display: flex;
        justify-content: space-between;
      }
      .vs__actions {
        right: 10px;
      }
    }
    .vs__actions {
      position: absolute;
      right: 00px;
      top: 0;
      bottom: 0;
      padding: 0;
    }
    .vs__selected {
      font-size: 14px;
      color: var(--color-primary-black-metallic);
      white-space: nowrap;
      @media (max-width: 768px) {
        white-space: normal;
        font-size: 12px;
      }
    }
  }
}
</style>
